import type { Board } from 'chessboard/model/board/types';
import { Core } from 'chessboard/core/config/types';
import { StateMachine } from 'chessboard/core/state/config/types';
import { cancelPromotion } from 'chessboard/core/state/machine/states/promotion/cancel-promotion';
import { Game } from 'chessboard/model/game/types';

export const promotionAreaShowing = {
  anyAPIEvent: (transitionParams: StateMachine.TransitionParams) => {
    if (transitionParams.type === Core.APIEvents.Move) {
      return StateMachine.States.PromotionAreaShowing;
    }

    return cancelPromotion(transitionParams);
  },

  /**
   * Choose the promotion piece to make the move.
   */
  [Core.BoardEvents.PromotionPiecePointerdown]: ({
    context,
    data: { piece },
    params: { draggingPiece, promotionMove },
    UpdateParams,
  }: StateMachine.TransitionParams) => {
    const {
      api: { move },
      queue,
      renderer,
    } = context;

    UpdateParams.dropPiece();
    UpdateParams.cancelPromotion();

    renderer?.dropPiece(<Board.SanSquare>draggingPiece, context);
    renderer?.closePromotionWindow(context);

    if (!promotionMove) {
      return StateMachine.States.Idle;
    }

    queue.add(move, {
      animate: false,
      flags: promotionMove.flags,
      from: promotionMove.from,
      piece: Game.Piece.Types.Pawn,
      promotion: piece,
      to: promotionMove.to,
      userGenerated: true,
    });

    return StateMachine.States.Idle;
  },

  /**
   * Close the window and reinstate the promoting piece.
   */
  [Core.BoardEvents.PromotionAreaClosePointerdown]: cancelPromotion,

  /**
   * Close the window and reinstate the promoting piece.
   */
  [Core.UserEvents.PointerdownLeft]: cancelPromotion,

  /**
   * Close the window and reinstate the promoting piece.
   */
  [Core.UserEvents.PointerdownRight]: cancelPromotion,
};
